import { Box } from "@mui/material";

// 背景は縦長の版デザインで、上端と下端に「YOU DON'T KNOW GUMMA」の帯が入っている。
// 帯だけを自然比率のまま上下に貼り、間はページの長さに応じて無地(fill)で埋める。
// 画像全体を引き伸ばすとページの長さで帯の比率が変わってしまうため、この形にしている。
// height は元画像のピクセル値。imageWidth との比がそのまま帯の縦横比になる。
const BACKGROUNDS = {
  // Heroを描くTicketsページ本体専用。Heroの無い状態(読み込み中/エラー等)では dark を使う。
  Tickets: {
    src: "/omagun/backgrounds/omagun_bg.webp",
    fill: "#171717",
    bands: {
      imageWidth: 828,
      // 414px幅でHero本体が終わるy=586。上の帯はHeroの直下から続ける。
      top: { offset: "min(141.5458937198vw, 586px)", height: 2368 },
      bottom: { height: 176 },
    },
  },
  Missions: {
    src: "/omagun/missions/missions_bg.webp",
    fill: "#e5e6e2",
  },
  dark: {
    src: "/omagun/backgrounds/dark_pages_bg.webp",
    // 帯の間を埋める無地。元画像の中央部と同じ色にしないと継ぎ目が見える。
    fill: "#1b1b1a",
    bands: {
      imageWidth: 828,
      top: { offset: 0, height: 300 },
      bottom: { height: 1012 },
    },
  },
};

// 元画像の端を切り出した帯。background-size: 100% auto で幅に合わせて自然比率に縮尺し、
// 要素の高さからはみ出した分は描かれないので、edge 側の帯だけが残る。
function Band({ src, ratio, edge, offset, testId }) {
  return (
    <Box
      data-testid={testId}
      sx={{
        position: "absolute",
        left: 0,
        width: "100%",
        [edge]: offset,
        aspectRatio: ratio,
        backgroundImage: `url(${src})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% auto",
        backgroundPosition: edge,
      }}
    />
  );
}

export default function OmagunBackground({ variant }) {
  const config = BACKGROUNDS[variant] || BACKGROUNDS.dark;
  const { bands } = config;

  return (
    <Box
      aria-hidden="true"
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 0,
        overflow: "hidden",
        pointerEvents: "none",
        backgroundColor: config.fill,
      }}
    >
      {bands ? (
        <>
          <Band
            testId="omagun-background"
            src={config.src}
            edge="top"
            offset={bands.top.offset}
            ratio={`${bands.imageWidth} / ${bands.top.height}`}
          />
          <Band
            testId="omagun-background-bottom"
            src={config.src}
            edge="bottom"
            offset={0}
            ratio={`${bands.imageWidth} / ${bands.bottom.height}`}
          />
        </>
      ) : (
        <Box
          component="img"
          data-testid="omagun-background"
          src={config.src}
          alt=""
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            minHeight: "100%",
            objectFit: "fill",
            display: "block",
          }}
        />
      )}
    </Box>
  );
}
